import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';
import logger from '../../utils/logger';

class BookingIntelligenceService {
  fetchMatches = async (
    tripId = null,
    shipmentId = null,
    page = 1,
    pageSize = 10,
  ) => {
    try {
      let url = `${BASE_URL}/v1/booking-intelligence/matches?page=${page}&pageSize=${pageSize}`;

      if (tripId) url += `&trip_id=${tripId}`;
      if (shipmentId) url += `&shipment_id=${shipmentId}`;

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      logger.error('Error fetching booking intelligence matches:', error);
      throw error;
    }
  };

  assignMatch = async (tripId, shipmentId) => {
    try {
      const url = `${BASE_URL}/v1/booking-intelligence/assign?trip_id=${tripId}&shipment_id=${shipmentId}`;
      const response = await axiosInstance.post(url);
      return response.data;
    } catch (error) {
      logger.error('Error assigning match:', error);
      throw error;
    }
  };
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new BookingIntelligenceService();
